import { render } from "./CommissionWeightedChart.vue?vue&type=template&id=1c915741"
import script from "./CommissionWeightedChart.vue?vue&type=script&lang=js"
export * from "./CommissionWeightedChart.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/CommissionWeightedChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c915741"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c915741', __exports__)) {
    api.reload('1c915741', __exports__)
  }
  
  module.hot.accept("./CommissionWeightedChart.vue?vue&type=template&id=1c915741", () => {
    api.rerender('1c915741', render)
  })

}


export default __exports__